import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=5c6cfb12&scoped=true"
import script from "./Issues.vue?vue&type=script&lang=ts"
export * from "./Issues.vue?vue&type=script&lang=ts"
import style0 from "./Issues.vue?vue&type=style&index=0&id=5c6cfb12&prod&lang=scss"
import style1 from "./Issues.vue?vue&type=style&index=1&id=5c6cfb12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6cfb12",
  null
  
)

export default component.exports